import { render, staticRenderFns } from "./index-property.vue?vue&type=template&id=8a004c64&scoped=true"
import script from "./index-property.vue?vue&type=script&lang=js"
export * from "./index-property.vue?vue&type=script&lang=js"
import style0 from "./index-property.vue?vue&type=style&index=0&id=8a004c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a004c64",
  null
  
)

export default component.exports